
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DescriptionsProps } from "antd";

import { Product } from "@/types/product";
import SText from "@/styles/SText";

type UseProduct = (props: {
  product: Product | null,
  miniStyle?: boolean;
}) => DescriptionsProps["items"]

const useProduct: UseProduct = ({ product, miniStyle = false }) => {
  const { t } = useTranslation();

  const items: DescriptionsProps["items"] = useMemo(() => [
    {
      key: "product",
      label: t("product.code"),
      children: product?.code || "",
      span: miniStyle ? 3 : undefined,
    },
    {
      key: "name",
      label: t("product.name"),
      children: product?.name || "",
      span: miniStyle ? 3 : undefined,
    },
    {
      key: "uom",
      label: t("product.uom"),
      children: product?.uom?.toLocaleUpperCase() || "",
      span: miniStyle ? 3 : undefined,
    },
    {
      key: "desc",
      label: t("common.desc"),
      children: <SText text={product?.desc || ""} style={{ width: "100%" }} />,
      span: miniStyle ? 3 : undefined,
    },
    {
      key: "brand1",
      label: t("product.brand1"),
      children: <SText text={product?.model?.toLocaleUpperCase() || ""} style={{ width: "100%" }} />,
      span: miniStyle ? 3 : undefined,
    },
    {
      key: "brand2",
      label: t("product.brand2"),
      children: <SText text={product?.t1?.toLocaleUpperCase() || ""} style={{ width: "100%" }} />,
      span: miniStyle ? 3 : undefined,
    },
    {
      key: "cbm",
      label: t("product.cbm"),
      children: product?.cbm || "",
      span: miniStyle ? 3 : undefined,
    },
  ], [t, product]);

  return items;
}

export default useProduct;